import React from 'react'
import Biote_aqua from '../../../images/Biote_aqua.png'
import aqua_floor from '../../../images/aqua_floor.png'
import aqua8 from '../../../images/aqua8.png'
import aqua9 from '../../../images/aqua9.png'
import './style.css'

const First_Pane = () => {
  return (
    <div>
            
            <div 
                style={{ backgroundImage: `url(${Biote_aqua})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                paddingBottom: '50px',
                paddingTop: '100px',
                height: '100vh'
            }}
    
            >
                <div className='uk-container uk-margin-xlarge-top'>
                    <div className='uk-grid'>
                        <div className='uk-width-1-2@s'>
    
                        <h1 className='light uk-text-bold header1' uk-scrollspy="cls: uk-animation-slide-top; repeat: true"></h1>
                        <h5 className='light uk-margin-small-top' uk-scrollspy="cls: uk-animation-slide-bottom; repeat: true">
        </h5>
                        </div>
    
                        <div className='uk-width-1-2@s'>
                            <div>
                                 <h5 className='light'>                                       
    </h5>
                             </div>
                        </div>
                    </div>
    
    
                </div>
               
              
            </div>


            <div className='uk-container'>

              <div className='uk-grid uk-margin-large-top uk-text-center'>
                  <div className='uk-width-1-2@s'>
                    <img src= {aqua8} />
                  </div>

                  <div className='uk-width-1-2@s'>
                    <img src= {aqua9} />
                  </div>
              </div>
              



                <div className='uk-text-center uk-margin-xlarge-top' >
                    <img src= {aqua_floor} />
                </div>


                   <div className='uk-grid uk-margin-large-top'>
                    <div className='uk-width-1-2@s'>
                        <h4 className='uk-text-bold'> FEATURES</h4>
                      <ol class="styled-list">
                        <li>Contemporary Design</li>
                        <li>4 Bedroom all En-suite</li>
                        <li>Sizeable Lounge + Dinning</li>
                        <li>Sizeable Kitchen + Store</li>
                        <li>Visitor’s Toilet</li>
                        <li>Private Family Lounge</li>
                        <li>Private Backyard</li>
                     </ol>


                     


                    </div>

                    <div className='uk-width-1-2@s'>
                        <div>
                            <h4 className='uk-text-bold'>GET STARTED TODAY WITH FLEXIBLE PAYMENT PLANS</h4>
                             <h5 className='uk-margin-top'>OFF-PLAN: N220M</h5>
                             <h5>DURING CONSTRUCTION: N250M - N270M</h5>
                             <h5>AT COMPLETION: N270M - N300M</h5>
                        </div>
                    </div>
               </div>


          </div>
    
  
            
        </div>
  )
}

export default First_Pane